'use strict';

var fragt = fragt || {};
var markers = markers || [];

fragt.map = fragt.map || new function () {

    this.init = function () {
        if (document.getElementById('map')) {
            initMap();
        }
    };

    function initMap() {

        var styles = [
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#efefef"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "hue": "#ff0000"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#e4eed2"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#a1b8c2"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#a1b8c2"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#b8cbe5"
                    }
                ]
            }
        ];

        var latValue = 56.290601;
        var lngValue = 12.045993;
        var zoomValue = 7;

        if (document.documentElement.clientWidth < 992) {
            latValue = 56.143988;
            lngValue = 10.156345;
            zoomValue = 6;
        }

        var map = new google.maps.Map(document.getElementById('map'), {
            center: { lat: latValue, lng: lngValue },
            zoom: zoomValue,
            styles: styles

        });

        var pin = '/dist/images/pin1.png';
        var companyNameElem = document.getElementById('department-companyname');
        var addressNameElem = document.getElementById('department-addressname');
        var address1Elem = document.getElementById('department-address1');
        var address2Elem = document.getElementById('department-address2');
        var phoneElem = document.getElementById('department-phone');
        var mailElem = document.getElementById('department-mail');
        var mondayElem = document.getElementById('department-monday');
        var tuesdayElem = document.getElementById('department-tuesday');
        var wednesdayElem = document.getElementById('department-wednesday');
        var thursdayElem = document.getElementById('department-thursday');
        var fridayElem = document.getElementById('department-friday');
        var saturdayElem = document.getElementById('department-saturday');
        var sundayElem = document.getElementById('department-sunday');
        var markerPins = [];
        var mapInfo = document.querySelector('#js-map-info');
        var closeBtn = document.querySelector('#js-close-icon');
       

        for (var i = 0; i < markers.length; i++) {
            var marker = new google.maps.Marker({
                position: { lat: markers[i].lat, lng: markers[i].lng },
                map: map,
                icon: pin,
                title: markers[i].addressName
            });
            
            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                
                return function () {
                    mapInfo.classList.add('show-map-info');
                    for (var j = 0; j < markerPins.length; j++) {
                        markerPins[j].setIcon(pin);
                    }
                    marker.setIcon('/dist/images/pin-active1.png');

                    companyNameElem.innerHTML = markers[i].companyName;
                    addressNameElem.innerHTML = markers[i].addressName;
                    address1Elem.innerHTML = markers[i].address1;
                    address2Elem.innerHTML = markers[i].address2;
                    phoneElem.innerHTML = markers[i].phone;
                    phoneElem.setAttribute('href', 'tel:' + markers[i].phone);
                    mailElem.innerHTML = markers[i].mail;
                    mailElem.setAttribute('href', 'mailto:' + markers[i].mail);
                    mailElem.setAttribute('title', markers[i].mail);
                    mondayElem.innerHTML = markers[i].monday;
                    tuesdayElem.innerHTML = markers[i].tuesday;
                    wednesdayElem.innerHTML = markers[i].wednesday;
                    thursdayElem.innerHTML = markers[i].thursday;
                    fridayElem.innerHTML = markers[i].friday;
                    saturdayElem.innerHTML = markers[i].saturday;
                    sundayElem.innerHTML = markers[i].sunday;
                };

            })(marker, i));

            markerPins.push(marker);
        }

        closeBtn.addEventListener('click', function () {
            mapInfo.classList.remove('show-map-info');
            for (var j = 0; j < markerPins.length; j++) {
                markerPins[j].setIcon(pin);
            }
        }, true); 
    }
}();
